import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/environmental-stewardship-desktop.webp';
import imageMobileWebp from './images/environmental-stewardship-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-environment-corporate-footprint'
    themeType='lightTheme'
    backgroundVariant='lightB'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent
    // content
    subHeadingText={<>Stewardship built into <WidowBlock>our operations</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <BulletedList
          bulletType='checkmark'
          bulletedListData={[
            {
              bulletText: <>
                <Typography
                  nextElement='typography'
                  weight={500}>
                  Office design
                </Typography>
                <Typography disableBottomPadding>
                  We design our offices in reference to Leadership in Energy and Environmental Design (LEED) and the WELL Building Standard best practices
                </Typography>
              </>,
            },
            {
              bulletText: <>
                <Typography
                  nextElement='typography'
                  weight={500}>
                  Energy efficiency
                </Typography>
                <Typography disableBottomPadding>
                  We regularly monitor our energy usage, which includes identifying opportunities for facility enhancements.
                </Typography>
              </>,
            },
            {
              bulletText: <>
                <Typography
                  nextElement='typography'
                  weight={500}>
                  Water conservation
                </Typography>
                <Typography disableBottomPadding>
                  We track water metrics to identify leaks and target upgrades, and we build conservation into our campus designs.
                </Typography>
              </>,
            },
            {
              bulletText: <>
                <Typography
                  nextElement='typography'
                  weight={500}>
                  Waste management
                </Typography>
                <Typography disableBottomPadding>
                  We minimize waste through educational campaigns and by reducing single&#45;use plastics on our campuses. Our recycling, composting, and reuse programs help lessen the impact of the waste we do generate.
                </Typography>
              </>,
            },
            {
              bulletText: <>
                <Typography
                  nextElement='typography'
                  weight={500}>
                  Carbon footprint
                </Typography>
                <Typography disableBottomPadding>
                  We account for our Scope 1 and 2 greenhouse gas emissions consistent with Greenhouse Gas Protocol guidelines.
                </Typography>
              </>,
            },
          ]}
        />
      </>
    )}
    // image props
    imageAltText='A view of the Northwestern Mutual tower building with lights as the sun fades away'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
